// extracted by mini-css-extract-plugin
export default {"messageBanner":"_25a32c80","success":"_e4bc5e1c","error":"_c06dbbc7","messageIcon":"_4ffe137f","failIcon":"_1c417e56","checkmarkIcon":"_db5515c7","message":"_ec597f94"};